import { render, staticRenderFns } from "./UserEditForm.vue?vue&type=template&id=67f5b93c&"
import script from "./UserEditForm.vue?vue&type=script&lang=js&"
export * from "./UserEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports